import {
  Alert,
  Button,
  ContentLayout,
  Header,
} from '@cloudscape-design/components';
import { ShippingSteps } from '@parallel-fluidics/shared/constants';
import CustomsForm from 'components/Orders/package/customsForm';
import ParcelForm from 'components/Orders/package/parcelForm';
import { useShipping } from 'components/Orders/package/shippingProvider';
import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';

import PackageInfo from '../packageInfo';
import SelectRate from '../selectRate';

export default function ShipmentsCreatePage() {
  const navigate = useNavigate();
  const { isInternational } = useShipping();

  const [page, setPage] = useState(ShippingSteps.PACKING_INFO);

  return (
    <ContentLayout
      header={(
        <Header
          actions={(
            <Button
              variant="normal"
              onClick={() => { navigate('/shipments'); }}
            >
              See all shipments
            </Button>
          )}
        >
          Create Shipment
        </Header>
      )}
    >
      <div style={{ display: 'flex', gap: 16, flexDirection: 'column' }}>
        <Alert
          type="warning"
          header="Don’t create a shipment here for an existing order."
        >
          We recommend creating a shipping label from the order page.
          Only use this page if the shipment is not associated with an order.
        </Alert>

        {page === ShippingSteps.PACKING_INFO && (
          <PackageInfo
            onNext={() => {
              if (isInternational) {
                setPage(ShippingSteps.CUSTOMS);
              } else {
                setPage(ShippingSteps.PARCEL);
              }
            }}
          />
        )}

        {page === ShippingSteps.CUSTOMS && (
          <CustomsForm
            onPrev={() => setPage(ShippingSteps.PACKING_INFO)}
            onNext={() => setPage(ShippingSteps.PARCEL)}
          />
        )}

        {page === ShippingSteps.PARCEL && (
          <ParcelForm
            onPrev={() => setPage(isInternational
              ? ShippingSteps.CUSTOMS
              : ShippingSteps.PACKING_INFO)}
            onNext={() => setPage(ShippingSteps.SELECT_RATE)}
          />
        )}

        {page === ShippingSteps.SELECT_RATE && (
          <SelectRate
            onPrev={() => {
              setPage(ShippingSteps.PARCEL);
            }}
            onNext={() => navigate('/shipments')}
          />
        )}

      </div>
    </ContentLayout>
  );
}
